// src/ProtectedRoute.js

import React from "react";
import { Navigate } from "react-router-dom";
import { auth } from "./firbase";
import { useAuthState } from "react-firebase-hooks/auth";

const ProtectedRoute = ({ children }) => {
  const [user] = useAuthState(auth);

  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
